<template>
	<el-drawer
		custom-class="flow-goods-drawer"
		:title="title"
		:visible.sync="visible"
		:size="1300"
		:append-to-body="true"
		:wrapperClosable="false"
		@closed="handleClose"
	>
		<div class="drawer-content">
			<panel>
				<search @search="search" ref="search" />
				<el-button class="export-button" type="primary" @click="onExport()">导出</el-button>
				<el-button class="export-button" @click="jumpRecord()">导出记录</el-button>
				<multi-table
					v-loading="loading"
					class="muti-table"
					ref="multiTable"
					:distanceTop="0"
					:columns="columns"
					@gePartnerList="gePartnerList"
					:list="tableData"
					:total="total"
					:page="pageInfo"
					:pageFixed="false"
				>
					<empty slot="empty"></empty>
				</multi-table>
			</panel>
		</div>
		<div class="bottom">
			<el-button @click="visible = false">取 消</el-button>
		</div>
	</el-drawer>
</template>
<script>
import search from './component/search.vue';
import { productClaimLogList, exportGoodsFlowRecord, productClaimLogReport } from '@/api/shopManage';
import getColumns from './columns';
import { mapGetters } from 'vuex';

export default {
	props: {
		platformId: {
			type: [String, Number],
			default: dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {
			visible: false,
			title: '商品流转记录',
			pageInfo: {
				page_size: 10,
				page_index: 1,
			}, //分页
			params: {},
			tableData: [],
			total: 0,
			loading: false,
		};
	},
	components: {
		search,
	},
	computed: {
		columns() {
			return getColumns(this);
		},
		...mapGetters(['defaultPlatform']),
	},
	methods: {
		// 打开弹窗
		show() {
			this.visible = true;
			this.circulation();
		},
		handleClose() {
			this.visible = false;
			this.$refs.search.clear();
			this.params = {};
			this.pageInfo = {
				page_index: 1,
				page_size: 10,
			};
			this.$emit('refresh');
		},
		// 搜索
		search(val) {
			this.params = val;
			this.pageInfo.page_index = 1;
			this.getList();
		},
		// 获取列表
		async getList() {
			try {
				this.loading = true;
				let params = {
					...this.pageInfo,
					...this.params,
					platformId: this.platformId,
				};
				let { data } = await productClaimLogList(params);
				this.tableData = data.list;
				this.total = data.page.item_total;
				return data.list;
			} finally {
				this.loading = false;
			}
		},
		// 分页
		gePartnerList(val) {
			this.pageInfo.page_index = val.page_index;
			this.pageInfo.page_size = val.page_size;
			this.getList();
		},
		// 导出
		async onExport() {
			const { code } = await exportGoodsFlowRecord({ ...this.params, platformId: this.platformId });
			if (code === 0) {
				this.jumpRecord();
			}
		},
		// 跳转导出记录
		jumpRecord() {
			const handLink = this.$router.resolve({
				path: '/shopManage/shopLibrary/record',
				query: { platform_id: this.platformId },
			});
			window.open(handLink.href, '_blank');
		},
		// todo wzj
		// 流转记录上报
		async circulation() {
			try {
				const retList = await this.getList();
				if (retList.length) {
					await productClaimLogReport({ productClaimId: retList[0].productClaimId });
				}
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-drawer__body {
	background: @color-gy2;
	padding: 0px 0px 0px !important;
}
.flow-goods-drawer {
	.drawer-content {
		padding: 16px;
	}
}
.export-button {
	margin-top: 14px;
}
.muti-table {
	margin-top: 10px;
}
.bottom {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2000;
}
</style>
